import axios, { type AxiosInstance } from 'axios'

const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.TEMBO_API_URL,
  headers: {},
})

export default apiClient

